import gql from 'graphql-tag';
import { UserShippingDiscountFragment } from '../fragments';

export default gql`
mutation createUserShippingDiscount (
    $user_id: ID!
    $is_active: Boolean!
    $discount: Float!
    $active_from: String!
    $active_to: String!
) {
    createUserShippingDiscount (input: {
        user_id: $user_id,
        is_active: $is_active,
        discount: $discount,
        active_from: $active_from,
        active_to: $active_to,
    }) {
        ...UserShippingDiscountFragment
    }
}
${UserShippingDiscountFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createUserShippingDiscount.ts